import { useEffect } from 'react';
import { resolveMediaUrl } from '@/lib/media-api';
import { THERME_SITE_TITLE } from './therme-groundbreaking-content';

export function useThermePageTitle(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const prevTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const prevDescription = meta?.getAttribute('content') ?? '';
    document.title = THERME_SITE_TITLE;
    if (meta) meta.setAttribute('content', THERME_SITE_TITLE);
    return () => {
      document.title = prevTitle;
      if (meta) meta.setAttribute('content', prevDescription);
    };
  }, [active]);
}

export function ThermeEventLogo({ event, className = '' }) {
  const src = resolveMediaUrl(event?.logo);
  if (src) {
    return (
      <img
        src={src}
        alt={THERME_SITE_TITLE}
        className={`h-8 w-auto max-w-[200px] object-contain ${className}`.trim()}
        data-testid="event-logo"
      />
    );
  }
  return (
    <span
      className={`font-heading text-sm md:text-base font-semibold tracking-tight truncate max-w-[min(100vw-8rem,300px)] ${className}`.trim()}
      data-testid="event-logo"
    >
      {THERME_SITE_TITLE}
    </span>
  );
}
